var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"p-0 m-0",attrs:{"fluid":"","id":"home"}},[_c('Banner'),_c('About'),_c('Specialty'),_c('Services'),_c('Contacts'),_c('Partners')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }